export const appUrl = "aeabridge2";

